var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 202,
    viewBox: "0 0 161 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_4094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.619 63.1105C123.619 63.1105 124.868 67.1678 125.715 67.9724",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.266 68.7343L129.658 67.1336C134.175 65.4045 154.541 56.2457 158.365 54.5252C157.98 52.8304 157.176 51.2982 156.705 50.5021L132.07 60.5255L131.429 58.942L157.372 48.3879L157.766 48.9528C157.843 49.0641 159.691 51.7861 160.187 54.8932L160.289 55.5352L159.691 55.8006C158.698 56.2457 135.287 66.8083 130.274 68.7257L130.266 68.7343Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.786 51.9915C150.786 51.9915 152.232 55.0216 152.822 56.357",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.176 53.4552L148.836 57.2728",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.623 56.9305L139.889 59.9007",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1436 178.213C19.1436 178.213 41.64 133.702 45.4122 117.542C49.1845 101.381 53.6752 71.6531 53.3587 67.2791C53.0422 62.9051 50.3136 15.5016 50.3136 15.5016C50.3136 15.5016 57.6869 13.5585 61.1512 20.8856L63.2897 1.71191C63.2897 1.71191 71.5526 1.74615 72.5534 9.27011C73.5542 16.7941 75.4018 41.6771 75.4018 41.6771L107.376 6.03455C107.376 6.03455 113.885 10.7595 111.995 18.1722C110.105 25.5849 96.7948 40.9581 94.7248 43.5944C92.6548 46.2308 86.8297 56.7592 86.8297 56.7592C86.8297 56.7592 93.0996 51.5378 96.8804 51.127C100.661 50.7161 135.826 49.7317 135.826 49.7317C135.826 49.7317 139.726 57.3755 126.502 62.3573L98.5997 66.7997C93.9208 67.5444 86.6415 85.8022 86.6415 85.8022C86.6415 85.8022 94.8531 87.9507 101.491 84.9805C101.491 84.9805 116.682 66.9966 129.085 67.7156C129.085 67.7156 132.746 68.3833 133.927 70.4034C133.927 70.4034 124.27 84.5269 121.327 91.3832C118.385 98.2395 101.268 130.364 101.268 130.364C101.268 130.364 94.1004 139.959 84.6228 144.35C84.6228 144.35 62.9304 198.276 62.1263 200.964C62.1263 200.964 31.8801 193.098 19.1436 178.213V178.213Z",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0405 28.0672C51.0405 28.0672 54.0258 27.3995 54.5647 26.5436C55.1036 25.6876 54.4963 18.8655 54.4963 18.8655",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9121 14.1406C61.9121 14.1406 64.3842 14.6114 65.4705 13.5756C66.5568 12.5399 66.8305 4.61365 66.8305 4.61365",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1598 20.8856C61.1598 20.8856 60.8689 32.3642 60.4498 35.1204C60.0307 37.8766 57.7553 49.5777 59.1753 53.0957",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3057 63.744L75.4015 41.6771",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7339 71.0539L86.8297 56.7678",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2009 68.4603C59.2009 68.4603 58.2172 72.0725 60.33 75.582",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5269 83.3114C71.5269 83.3114 69.2687 81.0773 70.2695 76.592",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2183 84.2701L86.6414 85.8108",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7603 92.9325C85.7603 92.9325 92.2269 96.1681 101.491 84.9891",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0273 15.3475C99.0273 15.3475 100.422 16.6572 102.44 16.0494C104.459 15.4417 107.179 12.0264 107.179 12.0264",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.834 50.0656C124.834 50.0656 125.467 52.8304 126.536 53.5237C127.605 54.2171 132.738 53.3012 132.738 53.3012",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.374 82.31C126.374 82.31 122.619 79.6051 122.602 77.6877C122.585 75.7704 126.81 71.5419 126.81 71.5419",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1538 144.607C75.1538 144.607 80.2519 145.575 84.6143 144.351",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.125 68.5973C124.193 67.7156 123.106 64.3688 122.798 63.3673L124.432 62.8623C125.005 64.7198 125.895 66.971 126.297 67.3561L125.125 68.5973Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7076 202L61.9121 201.795C60.6632 201.469 31.2639 193.689 18.5016 178.769L18.1338 178.332L18.3904 177.827C18.6128 177.382 40.8869 133.223 44.5907 117.345C48.457 100.739 52.8023 71.2851 52.52 67.339C52.2121 63.0164 49.5005 16.0237 49.4749 15.5444L49.4321 14.8425L50.1079 14.6627C50.1763 14.6456 56.566 13.045 60.5948 18.2835L62.5365 0.847412H63.3063C63.3919 0.847412 72.322 0.975807 73.4169 9.15031C74.2466 15.3646 75.658 33.5283 76.1199 39.6057L107.256 4.88758L107.88 5.34125C108.162 5.54668 114.843 10.5027 112.824 18.3862C111.131 25.0114 101.029 37.2689 96.7174 42.4988C96.1187 43.2264 95.6568 43.7828 95.3916 44.1252C94.1342 45.7173 91.4227 50.3652 89.5494 53.6607C91.7391 52.1713 94.6047 50.5107 96.7859 50.271C100.55 49.8602 134.363 48.91 135.8 48.8758L136.339 48.8587L136.587 49.338C136.638 49.4493 137.921 52.0086 136.672 55.2271C135.406 58.4883 132.087 61.159 126.801 63.1534L126.63 63.1962L98.7276 67.6386C95.8022 68.1009 90.6528 78.2698 87.813 85.1774C90.0883 85.614 96.0075 86.41 100.96 84.2701C102.577 82.387 116.904 66.1578 129.128 66.8511H129.23C129.641 66.9367 133.311 67.6643 134.662 69.9583L134.936 70.4291L134.628 70.8742C134.534 71.0112 124.979 85.0062 122.105 91.7085C119.18 98.522 102.714 129.44 102.012 130.749L101.944 130.86C101.653 131.254 94.6902 140.473 85.281 144.967C83.5018 149.384 63.6913 198.679 62.9385 201.195L62.699 201.983L62.7076 202ZM20.1696 178.084C31.6573 191.035 56.891 198.602 61.587 199.929C64.2045 192.833 82.9886 146.122 83.8269 144.034L83.9552 143.717L84.2631 143.572C93.0906 139.48 99.9764 130.646 100.55 129.902C101.388 128.327 117.708 97.6574 120.548 91.0494C123.209 84.8436 131.121 73.0398 132.891 70.4291C131.891 69.342 129.838 68.7343 128.991 68.5716C117.161 67.9553 102.303 85.3657 102.149 85.5369L102.021 85.6824L101.841 85.7595C95.0152 88.8239 86.7779 86.7182 86.4272 86.6326L85.4949 86.3843L85.8541 85.4856C86.6154 83.5682 93.4585 66.7484 98.471 65.9524L126.288 61.527C130.967 59.7466 134.003 57.3756 135.073 54.6536C135.774 52.8646 135.492 51.3495 135.252 50.6049C130.59 50.7333 100.404 51.6063 96.9741 51.9744C93.5012 52.351 87.4366 57.367 87.3767 57.4184L83.8868 60.3287L86.0851 56.3484C86.3246 55.9119 91.9615 45.7258 94.0572 43.0638C94.3309 42.7128 94.8014 42.1479 95.4087 41.4118C99.2836 36.7125 109.574 24.2154 111.173 17.9582C112.585 12.4287 108.958 8.53401 107.478 7.21582L74.7085 43.74L74.5631 41.737C74.546 41.4888 72.7155 16.7941 71.7233 9.38142C71.3469 6.5824 69.8329 4.58799 67.224 3.44956C65.9922 2.91886 64.8033 2.70486 64.0676 2.61927L61.6897 23.9671L60.3981 21.2451C57.8234 15.8097 53.0076 15.9381 51.2284 16.1949C51.5791 22.2637 53.9399 63.2047 54.2308 67.2192C54.5558 71.7473 49.9967 101.698 46.2586 117.738C42.6832 133.069 22.8213 172.837 20.1867 178.084H20.1696Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0405 28.0672C51.0405 28.0672 54.0258 27.3995 54.5647 26.5436C55.1036 25.6876 54.4963 18.8655 54.4963 18.8655",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9121 14.1406C61.9121 14.1406 64.3842 14.6114 65.4705 13.5756C66.5568 12.5399 66.8305 4.61365 66.8305 4.61365",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1598 20.8856C61.1598 20.8856 60.8689 32.3642 60.4498 35.1204C60.0307 37.8766 57.7553 49.5777 59.1753 53.0957",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3057 63.744L75.4015 41.6771",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7339 71.0539L86.8297 56.7678",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2009 68.4603C59.2009 68.4603 58.2172 72.0725 60.33 75.582",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5269 83.3114C71.5269 83.3114 69.2687 81.0773 70.2695 76.592",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2183 84.2701L86.6414 85.8108",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7603 92.9325C85.7603 92.9325 92.2269 96.1681 101.491 84.9891",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0273 15.3475C99.0273 15.3475 100.422 16.6572 102.44 16.0494C104.459 15.4417 107.179 12.0264 107.179 12.0264",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.834 50.0656C124.834 50.0656 125.467 52.8304 126.536 53.5237C127.605 54.2171 132.738 53.3012 132.738 53.3012",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.374 82.31C126.374 82.31 122.619 79.6051 122.602 77.6877C122.585 75.7704 126.81 71.5419 126.81 71.5419",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1538 144.607C75.1538 144.607 80.2519 145.575 84.6143 144.351",
    stroke: "#72E9AF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.893 22.4092H107.812V24.1212H123.893V22.4092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6227 124.124H33.2485V125.836H41.6227V124.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6115 113.972H19.2373V115.684H27.6115V113.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.78 147.244H124.406V148.956H132.78V147.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.326 181.979H100.952V183.691H109.326V181.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37416 74.7261H0V76.438H8.37416V74.7261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3366 175.901H70.9624V177.613H79.3366V175.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.589 124.124H103.099V125.836H128.589V124.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1656 139.206H10.6753V140.918H36.1656V139.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4368 162.548H26.7734V164.26H33.4368V162.548Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5531 106.756H48.0381V108.468H61.5531V106.756Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6761 196.137H63.1611V197.849H76.6761V196.137Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.827 92.5131H118.872V94.225H148.827V92.5131Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.067 131.622H40.9385V133.334H52.067V131.622Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.715 36.9949H123.2V38.7069H136.715V36.9949Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.694 36.9949H99.5659V38.7069H109.694V36.9949Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4166 43.3548H9.05859V45.0667H29.4166V43.3548Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6857 129.046C99.3606 129.474 96.9057 132.615 93.1934 135.979H95.7253C98.9415 132.872 100.935 130.227 101.089 130.022L101.157 129.91C101.491 129.294 105.314 122.104 109.574 113.964H107.641C103.603 121.659 100.062 128.327 99.6771 129.037L99.6857 129.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4259 144.128C88.0099 142.416 91.2347 140.019 93.8778 137.691H91.209C88.908 139.574 86.2564 141.397 83.3994 142.724L83.0915 142.87L82.9632 143.186C82.6381 144 79.6101 151.524 75.8721 160.845H77.7197C81.0813 152.457 83.8185 145.652 84.4259 144.137V144.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.013 29.7791C99.8313 34.136 96.4269 38.2703 94.5365 40.5558C93.9292 41.2919 93.4588 41.8654 93.185 42.2078C93.1166 42.2934 93.0396 42.3875 92.9712 42.4903H95.161C95.3663 42.242 95.5972 41.9596 95.8624 41.6429C98.0692 38.9637 101.799 34.4356 105.135 29.7706H103.013V29.7791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1516 58.3343H52.8624C52.0669 45.0154 50.6213 19.9869 50.3561 15.339C52.1353 15.0822 56.9511 14.9623 59.5258 20.3892L60.8174 23.1111L63.1953 1.7633C63.931 1.84889 65.1199 2.06288 66.3517 2.59358C68.9606 3.72346 70.4832 5.71787 70.851 8.52545C71.8432 15.9381 73.6737 40.6328 73.6908 40.8811L73.8363 42.884L106.614 6.35985C108.103 7.67804 111.73 11.5813 110.31 17.1022C109.591 19.9184 107.11 24.0014 104.245 28.0586H106.341C109.009 24.1811 111.251 20.3464 111.969 17.5217C113.988 9.6382 107.307 4.68215 107.025 4.47672L106.401 4.02305L75.2562 38.7411C74.7943 32.6723 73.3829 14.5001 72.5532 8.28578C71.4583 0.128396 62.5281 0 62.4426 0H61.6728L59.7311 17.4361C55.7022 12.1976 49.3125 13.7982 49.2441 13.8153L48.5684 13.9951L48.6111 14.697C48.6368 15.065 50.2791 43.6715 51.1516 58.3343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.492 48.0113L134.953 48.0284C133.516 48.0712 99.7031 49.0213 95.9394 49.4236C93.7582 49.6633 90.8927 51.3239 88.7029 52.8132C90.2939 50.0228 92.4751 46.2651 93.8694 44.2108H91.825C89.3017 48.1396 85.4354 55.1415 85.2301 55.501L83.0317 59.4812L86.5217 56.5709C86.5816 56.5196 92.6376 51.5036 96.119 51.127C99.5491 50.7589 129.735 49.8858 134.397 49.7574C134.628 50.4936 134.919 51.9915 134.226 53.7719C133.165 56.511 130.129 58.8992 125.424 60.6796L97.6074 65.1049C92.5863 65.901 85.7518 82.7208 84.9906 84.6381L84.6313 85.5369L85.5637 85.7851C85.9144 85.8793 94.1517 87.9764 100.978 84.912L101.157 84.835L101.286 84.6895C101.431 84.5097 116.297 67.1079 128.127 67.7242C128.974 67.8868 131.027 68.486 132.028 69.5817C130.257 72.1924 122.345 84.0047 119.685 90.2019C118.222 93.6001 113.201 103.367 108.548 112.269H110.481C115.023 103.581 119.804 94.2592 121.259 90.8782C124.133 84.1759 133.687 70.1808 133.781 70.0439L134.089 69.5988L133.816 69.128C132.473 66.834 128.803 66.1064 128.384 66.0294H128.281C116.066 65.3361 101.73 81.5481 100.114 83.4312C95.1696 85.5711 89.2503 84.7751 86.9665 84.3386C89.8149 77.4309 94.9557 67.2705 97.8811 66.7998L125.784 62.3573L125.955 62.3145C131.241 60.3201 134.568 57.6495 135.826 54.3882C137.066 51.1698 135.792 48.6019 135.74 48.4992L135.492 48.0198V48.0113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1963 162.548C69.4054 176.997 62.2715 194.895 60.7318 199.073C56.0358 197.754 30.8021 190.171 19.3144 177.228C20.6402 174.592 26.3114 163.25 32.0766 150.659H30.1777C23.8051 164.526 17.6464 176.732 17.5266 176.963L17.27 177.468L17.6378 177.904C30.4001 192.815 59.808 200.605 61.0483 200.93L61.8438 201.135L62.0833 200.348C62.5623 198.756 70.6884 178.384 77.0353 162.54H75.1877L75.1963 162.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6478 66.4831C51.7932 68.5631 50.6641 77.7048 48.9961 88.3188H50.7325C52.3834 77.8332 53.521 68.7 53.3585 66.3632C53.2987 65.5586 53.1618 63.2561 52.9651 60.0462H51.2543C51.451 63.316 51.5964 65.6699 51.6563 66.4831H51.6478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3863 116.882C47.0885 109.581 48.9618 99.3951 50.4587 90.0308H48.7223C47.2938 98.9671 45.5146 108.699 43.821 116.052H44.5993V117.764H43.3933C41.4088 125.185 36.191 137.477 30.9561 148.947H32.855C38.3123 136.955 43.6841 124.158 45.3863 116.874V116.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.729 80.598H151.907V82.31H153.729V80.598Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0807 28.9232H35.2588V30.6351H37.0807V28.9232Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0807 79.1H35.2588V80.812H37.0807V79.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.473 148.1H98.6509V149.812H100.473V148.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.716 107.612H125.895V109.324H127.716V107.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.238 84.9548H158.416V86.6668H160.238V84.9548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.609 158.945H108.787V160.657H110.609V158.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3356 95.2436H22.5137V96.9555H24.3356V95.2436Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7658 162.548H90.9438V164.26H92.7658V162.548Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5378 57.8292H40.7158V59.5412H42.5378V57.8292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2424 59.1902H23.4204V60.9021H25.2424V59.1902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_4094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.272,
    height: 202,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow);
export default __webpack_public_path__ + "static/media/how.9835ad764db8f3e5cb1e7e8f0db1b657.svg";
export { ForwardRef as ReactComponent };